import { render, staticRenderFns } from "./without_plagiarism.vue?vue&type=template&id=7e3ac953&scoped=true&"
import script from "./without_plagiarism.vue?vue&type=script&lang=js&"
export * from "./without_plagiarism.vue?vue&type=script&lang=js&"
import style0 from "./without_plagiarism.vue?vue&type=style&index=0&id=7e3ac953&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3ac953",
  null
  
)

export default component.exports